import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { pageJsonLd } from '../../helpers/JsonLdHelpers';
import Share from '../../data/models/Share';
import { app } from '../../configuration';
import { assetUrl } from '../../helpers/UrlHelpers';
import { getCanonicalURL } from '../../utils/URLUtils';
export var pageBySlug = function pageBySlug(data) {
  return data == null ? void 0 : data.pageBySlug;
};
export function transformJsonld(data, _ref) {
  var title = _ref.title;
  if (data) {
    if (title) {
      return pageJsonLd(_objectSpread(_objectSpread({}, data), {}, {
        share: _objectSpread(_objectSpread({}, data.seo), {}, {
          title: title
        }),
        url: getCanonicalURL("".concat(app.APP_URL).concat(data.fullSlug))
      }));
    }
    return pageJsonLd(_objectSpread(_objectSpread({}, data), {}, {
      url: getCanonicalURL("".concat(app.APP_URL).concat(data.fullSlug))
    }));
  }
  return {};
}
export function transformSeo(data, params) {
  if (data) {
    var transformedShare = Share(_objectSpread({
      title: data.title
    }, data.seo));
    return _objectSpread(_objectSpread(_objectSpread({
      title: data.title
    }, transformedShare), params), {}, {
      url: getCanonicalURL(params.url || "".concat(app.APP_URL).concat(data.fullSlug)),
      image: transformedShare.image ? assetUrl(transformedShare.image, {
        width: 1024
      }) : '',
      noindex: false
    });
  }
  return {};
}